/**
 * localStorage with the "spacexr:" prefix (the production origin is shared with other apps).
 */
import { storageKey } from '@clinspace/shared';

export function loadItem<T>(name: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(storageKey(name));
    return raw === null ? fallback : (JSON.parse(raw) as T);
  } catch {
    return fallback;
  }
}

export function saveItem(name: string, value: unknown): void {
  try {
    localStorage.setItem(storageKey(name), JSON.stringify(value));
  } catch {
    /* private mode or quota: ignore */
  }
}

export function removeItem(name: string): void {
  try {
    localStorage.removeItem(storageKey(name));
  } catch {
    /* ignore */
  }
}
